import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import type { RootState, AppDispatch } from "App/store/store";

/**
 * Use these instead of the plain `useDispatch` / `useSelector` so thunks are
 * dispatchable without a cast and state is typed at every call site.
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
